import axios from '@/util/request'

const baseURL = process.env.VUE_APP_API_URL

export default {
  // 下拉列表接口
  orderGetAllPlatform: params => axios({ baseURL, url: '/api/store/allPlatform', method: 'get', params }), // 平台下拉
  orderGetAllStore: data => axios({ baseURL, url: `/api/store/allStore`, method: 'post', data }), // 店铺下拉
  orderDropDownInfo: params => axios({ baseURL, url: `/api/system/dropDownInfo`, method: 'get', params }), // 获取公共下拉 订单状态传：4  退款下拉传：5   承运商： 8
  orderSignValue: params => axios({ baseURL, url: `/api/system/signValue`, method: 'get', params }), // 获取阿里云文件服务器上传校验秘钥
  orderUploadFile: data => axios({ baseURL, url: `/api/hbo/uploadFile`, method: 'post', data }), // 上传文件阿里云文件服务器
  orderDownloadInvoice: kkOrderId => axios({ baseURL, url: `/api/orders/orders/${kkOrderId}/downloadInvoice`, method: 'get', responseType: 'blob' }), // 下载发票
  orderLogisticsTrackInfo: data => axios({ baseURL, url: `/api/orders/logisticsTrackInfo`, method: 'post', data }), // 获取物流轨迹
  orderCancelFulfillment: data => axios({ baseURL, url: `/api/orders/cancelFulfillment`, method: 'put', data }), // 前台-接受or拒绝客户发起的取消交运请求(Shopify订单)

  // 支付页面
  orderGetList: data => axios({ baseURL, url: '/api/orders/orderList', method: 'post', data }), // 获取订单列表
  // orderGetList: data => axios({ baseURL: 'http://10.0.2.6:8102', url: '/api/orders/orderList', method: 'post', data }), // 获取订单列表
  orderGetDetail: kkOrderId => axios({ baseURL, url: `/api/orders/orders/${kkOrderId}`, method: 'get' }), // 查询订单详情
  orderGetStatement: kkOrderid => axios({ baseURL, url: `/api/orders/orders/${kkOrderid}/statement`, method: 'get' }), // 查询收入证明

  getKeyCustomerSampleOrders: data => axios({ baseURL, url: `/api/orders/customer/getSampleOrders`, method: 'post', data }), // 获取大客户样品订单列表

  getPermissionData: data => axios({ baseURL, url: `/api/orders/customer/getPermissionData`, method: 'post', data }), // 大客户样品订单权限数据列表

  getUserCouponTicketDetail: (data) => axios({ url: '/api/product/userCouponTicketDetail', method: 'POST', data }), // 前后台（PC端或移动端）-获取用户已领取优惠券详情

  orderReceipt: omsPackId => axios({ baseURL, url: `/api/orders/orders/${omsPackId}/receipt`, method: 'put' }), // 确认收货
  orderCancel: data => axios({ baseURL, url: `/api/orders/orders`, method: 'put', data }), // 取消订单
  orderRefund: data => axios({ baseURL, url: `/api/orders/orders/${data.get('kkOrderId')}/refund`, method: 'put', data }), // 申请退款
  orderRulfillment: data => axios({ baseURL, url: `/api/orders/fulfillment`, method: 'post', data }), // 订单标记
  importExportFile: data => axios({ baseURL, url: `/api/admin/importExportFile`, method: 'post', data }), // 新增导入导出任务
  fileTaskById: params => axios({ baseURL, url: `/api/admin/fileTask`, method: 'get', params }), // 根据任务id获取任务信息
  whetherToPay: data => axios({ baseURL, url: `/api/orders/orders/check/whetherToPay`, method: 'post', data }), // 校验批量付款
  getProductAttachments: kkOrderId => axios({ baseURL, url: `/api/orders/orders/attachments/${kkOrderId}`, method: 'get' }), // 获取用户配件信息
  getNewProductAttachments: params => axios({ baseURL, url: `/api/orders/orders/attachments`, method: 'get', params }), // 获取用户配件信息
  putProductAttachments: data => axios({ baseURL, url: `/api/orders/orders/attachment`, method: 'put', data }), // 编辑订单附件信息
  orderOosSplit: kkOrderId => axios({ baseURL, url: `/api/orders/orders/oosSplit/${kkOrderId}`, method: 'put' }), // 缺货拆单调用

  // 编辑自动支付状态
  setAutomaticPayment: status => axios({ baseURL, url: `/api/store/user/automaticPayment/${status}`, method: 'put' }), // 编辑自动支付状态

  // 订单列表 触发拆单
  clickAutomaticSplitPack: kkOrderId => axios({ baseURL, url: `/api/orders/${kkOrderId}/automaticSplitPack`, method: 'put' }), // 自动拆包接口（open Api或第三方订单）

  // 修改订单优惠信息
  updateOrdersCoupon: (data, kkOrderId) => axios({ baseURL, url: `/api/orders/orders/coupon/${kkOrderId}`, method: 'put', data })

}
